import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ColDef } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-theme-alpine.css';

type Roster = {
  player_id: string;
  player_name: string;
  position: string;
  player_class?: string;
  class?: string; // For backward compatibility
  jersey?: string | number;
};

interface TeamRostersTableProps {
  roster: Roster[];
  teamName?: string;
  teamCode?: number;
}

const TeamRostersTable: React.FC<TeamRostersTableProps> = ({ roster, teamName, teamCode }) => {
  const rowData = useMemo(() => roster.map(p => ({
    Name: p.player_name,
    Position: p.position,
    Class: p.player_class || p.class || '-',  // Fallback to p.class for backward compatibility
    Jersey: typeof p.jersey === 'number' ? p.jersey : p.jersey || '-',
  })), [roster]);

  const columnDefs: ColDef[] = [
    { headerName: "Name", field: "Name", sortable: true, filter: true, flex: 1 },
    { headerName: "Position", field: "Position", sortable: true, filter: true, flex: 1 },
    { headerName: "Class", field: "Class", sortable: true, filter: true, flex: 1 },
    { headerName: "Jersey #", field: "Jersey", sortable: true, filter: true, flex: 1 },
  ];

  const logoUrl = teamCode ? `https://premier.athlytesports.com/assets/images/teams/${teamCode}.png` : undefined;

  return (
    <div className="p-4 bg-white shadow-md rounded-md overflow-x-auto mb-6">
      <div className="flex items-center mb-2">
        {teamCode && <img src={logoUrl} alt={teamName} className="w-6 h-6 mr-1" onError={e => {(e.target as HTMLImageElement).style.display='none';}} />}
        <span className="font-semibold">{teamName}</span>
      </div>
      <div className="ag-theme-alpine" style={{ width: '100%', height: '400px' }}>
        <AgGridReact<any>
          modules={[AllCommunityModule]}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={{ sortable: true, filter: true, resizable: true }}
        />
      </div>
    </div>
  );
};

export default TeamRostersTable;
